/**
 * Top-Collector 페이지 Config
 *
 * 팀별 top-collector 페이지 설정
 */

import type { TeamSlug } from '@/app/(football)/[team]/_context/types';
import type { TopCollectorPageConfig } from '@/app/(football)/[team]/top-collector/_context/types';

import { bluewingsConfig } from './bluewings';
import { dhcfcConfig } from './dhcfc';
import { fcanyangConfig } from './fcanyang';
import { fcseoulConfig } from './fcseoul';
import { jbfcConfig } from './jbfc';
import { steelersConfig } from './steelers';
import { uhdfcConfig } from './uhdfc';

export const topCollectorConfig: Record<TeamSlug, TopCollectorPageConfig> = {
  fcseoul: fcseoulConfig,
  bluewings: bluewingsConfig,
  steelers: steelersConfig,
  fcanyang: fcanyangConfig,
  uhdfc: uhdfcConfig,
  dhcfc: dhcfcConfig,
  jbfc: jbfcConfig,
};
